import { render, staticRenderFns } from "./RefractiveDepartmentHome.vue?vue&type=template&id=59986942&scoped=true&"
import script from "./RefractiveDepartmentHome.vue?vue&type=script&lang=js&"
export * from "./RefractiveDepartmentHome.vue?vue&type=script&lang=js&"
import style0 from "./RefractiveDepartmentHome.vue?vue&type=style&index=0&id=59986942&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59986942",
  null
  
)

export default component.exports